export const STAGES = [
  {
    id: 'domain',
    title: 'The Domain',
    prompt: 'Name your goal domain. Is it finances, fitness, creative work, career, or something else?',
    hint: 'Choose the arena where you seek transformation.',
    placeholder: 'e.g., Financial Mastery, Physical Vitality, Professional Excellence, or Creative Legacy...',
    getAck: () => null
  },
  {
    id: 'desire',
    title: 'Stage 1: The Exact Desire',
    prompt: 'Fix in your mind the exact outcome you desire. Not "better." Not "plenty." The exact outcome. Until you can name precisely what you want, you don\'t have a desire yet. You have a direction.',
    hint: 'A burning desire has a name. Give yours one.',
    placeholder: 'Example: "I desire a net worth of $100,000 in liquid assets." (Avoid vague terms like "more money" or "being rich").',
    getAck: (ans) => `You have chosen the domain of ${ans.domain}. Now, define your destination with absolute precision.`
  },
  {
    id: 'exchange',
    title: 'Stage 2: The Exchange',
    prompt: 'Decide what you are willing to give in return for what you want. Nothing arrives without a price. The world doesn\'t reward want; it rewards contribution.',
    hint: 'Name your offering. Time, skill, service, sacrifice.',
    placeholder: 'Example: "I will give 3 hours of deep, uninterrupted work every morning and sacrifice my weekend leisure time to build this enterprise."',
    getAck: () => `Your desire is fixed. Now, name the price you are willing to pay.`
  },
  {
    id: 'deadline',
    title: 'Stage 3: The Deadline',
    prompt: 'Name the exact date by which you will have what you want. A goal with no deadline is just a preference. A date transforms a want into a commitment.',
    hint: 'Set the date that makes it real. Choose an actual deadline.',
    placeholder: 'Example: "December 31st, 2025." (A specific day, month, and year provides the necessary urgency).',
    getAck: () => `The price is named. Now, anchor this manifestation in time.`
  },
  {
    id: 'plan',
    title: 'Stage 4: The Plan',
    prompt: 'Write your plan and begin today. Not when you feel ready. Today. Readiness is a myth. The ones who move forward simply stopped waiting for a feeling that was never going to come.',
    hint: 'One real step taken today is worth a thousand perfect steps planned for later.',
    placeholder: 'Example: "I will research the top 3 brokerage firms today and open my account before 5:00 PM tonight."',
    getAck: () => `Time is bound. Now, forge the immediate path.`
  },
  {
    id: 'oath',
    title: 'Stage 5: The Declaration',
    prompt: 'Distill your commitment into a single, powerful sentence. State exactly what you will achieve and by when. This is your ultimate, unwavering goal.',
    hint: 'Keep it focused. State what you are claiming as if it is already yours.',
    placeholder: 'Example: "I possess $100,000 in my accounts by Dec 31st, 2025, through my relentless service and daily discipline."',
    getAck: () => `The path is clear. Now, forge your central declaration into a decree.`
  },
  {
    id: 'ritual',
    title: 'Stage 6: The Daily Ritual',
    prompt: 'Read your statement aloud twice every day. Once in the morning, once at night. As you read it, do not just say the words—feel what it would actually feel like to have arrived. Words carried on the current of genuine feeling become instructions the deeper mind cannot ignore.',
    hint: 'Set your two times now. Morning and night. Consistency is the commitment.',
    placeholder: 'Example: "Morning: 6:30 AM (immediately upon waking). Night: 10:15 PM (just before sleep)."',
    getAck: () => `The oath is written. Now, make it a living practice with these specific times.`
  }
];